<template>
  <div>
    <keep-alive :include="keepAlive">
      <router-view :key="$route.fullPath"></router-view>
    </keep-alive>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isPk: false,
      keepAlive: [],
    };
  },
  computed: {
    ...mapState(["hasLogin", "token", "isGetPk"]),
  },
  watch: {
    $route: {
      handler(to, from) {
        // 如果是从b到a页面，则不缓存b
        // 注意 路由那么要与组件name一致
        // rootPage 是否为根页面  到达根页面 清空keepalive 缓存页面
        if (to.meta.rootPage) {
          this.keepAlive = [];
        } else if (to.meta.KeepAlive) {
          if (to.matched.length > 1) {
            this.addUnique(to.matched[0].name);
          } else {
            this.addUnique(to.name);
          }
        } else if (from && from.meta.KeepAlive) {
          if (from.matched.length > 1) {
            this.addUnique(from.matched[0].name);
          } else {
            this.addUnique(from.name);
          }
        }
      },
      immediate: true,
    },
  },
  async created() {
    if (
      sessionStorage.getItem("webIp") == null ||
      sessionStorage.getItem("webIp") == ""
    ) {
      await this.getWebIp();
    }
    // if (this.isGetPk) {
    //   await this.getPk();
    // }
    // this.getTable();
    if (!this.getCookie("close")) localStorage.removeItem("close");
    if (!this.$global.ispc) {
      let vm = this;
      window.document.onvisibilitychange = function () {
        if (document.visibilityState == "visible") {
          // if (
          //   (!vm.hasLogin && sessionStorage.getItem("token")) ||
          //   (vm.hasLogin && vm.token !== sessionStorage.getItem("token"))
          // ) {
          // window.location.reload();
          // } else
          if (
            vm.hasLogin &&
            (sessionStorage.getItem("token") == "" ||
              sessionStorage.getItem("token") == null)
          ) {
            vm.$store.commit("logOut");
          }
        }
      };
    }
  },
  methods: {
    addUnique(element) {
      if (!this.keepAlive.includes(element)) {
        this.keepAlive.push(element);
      }
    },
    async getWebIp() {
      try {
        let res = await this.$apis.common.getUserIpConfig();
        if (res.status === 0) {
          sessionStorage.setItem("webIp", res.result.ip);
        } else {
          sessionStorage.setItem("webIp", "103.43.184.186");
        }
      } catch (error) {
        sessionStorage.setItem("webIp", "103.43.184.186");
      }
    },
    async getPk() {
      let { pk, token } = await this.$apis.mainServe.getPk();
      sessionStorage.setItem("trip", pk);
      this.isPk = true;
      var u = navigator.userAgent;
      var isWeixin = u.toLowerCase().indexOf("micromessenger") !== -1; // 微信内
      if (this.$global.ispc || isWeixin) {
        if (token) {
          sessionStorage.setItem("token", token);
        } else if (sessionStorage.getItem("token")) {
          this.$store.commit("clearInfo");
          if (this.$global.ispc) window.location.href = this.$global.SeoUrl;
        }
      }
    },
    // async getTable() {
    //   let res = await this.$apis.recomendServe.getTable();
    //   this.$store.commit("getTable", res);
    // },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";"); //把cookie分割成组
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]; //取得字符串
        while (c.charAt(0) == " ") {
          //判断一下字符串有没有前导空格
          c = c.substring(1, c.length); //有的话，从第二位开始取
        }
        if (c.indexOf(nameEQ) == 0) {
          //如果含有我们要的name
          return unescape(c.substring(nameEQ.length, c.length)); //解码并截取我们要值
        }
      }
      return false;
    },
  },
};
</script>
<style lang="scss"></style>
<style>
.ivu-modal-wrap {
  display: flex;
  align-items: center;
}

.ivu-modal {
  top: 0 !important;
}
.myToast {
  z-index: 9999 !important;
}
</style>
